import { FbBetItemOption } from '../util/Constants';
export class MatchDetailsHeaderObject {
  public id:number;
  public matchNum: number;
  public dayOfWeek: number;
  public startTime: string;
  public currentMin: number;
  public matchProgress: number;
  public homeName: string;
  public awayName: string;
  public homeScore: string;
  public awayScore: string;
  public corner: string;
  public firstHalfHomeScore: string;
  public firstHalfAwayScore: string;
  public tipsPublishClosed: boolean;
  public bet: Array<FbBetRow>;
  public matchDay: string;
  public date: string;


  constructor(id: number, matchNum: number, dayOfWeek: number, startTime: string, currentMin: number, matchProgress: number, homeName: string, awayName: string, homeScore: string,
      awayScore: string, corner: string, firstHalfHomeScore: string, firstHalfAwayScore: string,
      tipsPublishClosed: boolean, bet: Array<FbBetRow>, matchDay: string, date: string) {
    this.id = id;
    this.matchNum = matchNum;
    this.dayOfWeek = dayOfWeek;
    this.startTime = startTime;
    this.currentMin = currentMin;
    this.matchProgress = matchProgress;
    this.homeName = homeName;
    this.awayName = awayName;
    this.homeScore = homeScore;
    this.awayScore = awayScore;
    this.corner = corner;
    this.firstHalfHomeScore = firstHalfHomeScore;
    this.firstHalfAwayScore = firstHalfAwayScore;
    this.tipsPublishClosed = tipsPublishClosed;
    this.bet = bet;
    this.matchDay = matchDay;
    this.date = date;
  }

  copy(matchDetailsHeaderObject: MatchDetailsHeaderObject) {
    this.id = matchDetailsHeaderObject.id;
    this.matchNum = matchDetailsHeaderObject.matchNum;
    this.dayOfWeek = matchDetailsHeaderObject.dayOfWeek;
    this.currentMin = matchDetailsHeaderObject.currentMin;
    this.startTime = matchDetailsHeaderObject.startTime;
    this.matchProgress = matchDetailsHeaderObject.matchProgress;
    this.homeName = matchDetailsHeaderObject.homeName;
    this.awayName = matchDetailsHeaderObject.awayName;
    this.homeScore = matchDetailsHeaderObject.homeScore;
    this.awayScore = matchDetailsHeaderObject.awayScore;
    this.corner = matchDetailsHeaderObject.corner;
    this.firstHalfHomeScore = matchDetailsHeaderObject.firstHalfHomeScore;
    this.firstHalfAwayScore = matchDetailsHeaderObject.firstHalfAwayScore;
    this.tipsPublishClosed = matchDetailsHeaderObject.tipsPublishClosed;
    this.bet = matchDetailsHeaderObject.bet;
    this.matchDay = matchDetailsHeaderObject.matchDay;
    this.date = matchDetailsHeaderObject.date;
  }

  public getFirstHalfScore(): string {
    let firstHalfHomeScore = Number(this.firstHalfHomeScore);
    let firstHalfAwayScore = Number(this.firstHalfAwayScore);

    if (firstHalfAwayScore < 0 || firstHalfHomeScore < 0) {
      return "-";
    } else {
      return firstHalfHomeScore + ":" + firstHalfAwayScore;
    }
  }

  public getCornerNum() {
    return this.corner == "-1" ? "-" : this.corner;
  }

  getBetRow(ibetType: number) {
    let bet: Array<FbBetRow> = [];
    for (let fbBetRow of this.bet) {
      if (fbBetRow.bet[0].betType == ibetType) {
        bet.push(fbBetRow);
      }
    }
    return bet;
  }

  isEnded() {
    return this.matchProgress == 4;
  }

  isMatchStarted() {
    return this.matchProgress >= 1;
  }

  isShowShareBtn() {
    return this.matchProgress == 4 || this.matchProgress == 6;
  }
}
export class FbBetRow {
  bet: Array<FbBet>;
  tipPublished: boolean;
  betAmount: number;
  createDate: string;
  price: number;

  constructor(bet: Array<FbBet>, tipPublished: boolean, betAmount: number, createDate: string, price: number) {
    this.bet = bet;
    this.tipPublished = tipPublished;
    this.betAmount = betAmount;
    this.createDate = createDate;
    this.price = price;
  }
}
export class FbBet {
  betType: number;
  itemOption: number;
  winningMargin: string;
  odds: number;
  selected: boolean;

  constructor(betType: number, itemOption: number, winningMargin: string, odds: number, selected: boolean) {
    this.betType = betType;
    this.itemOption = itemOption;
    this.winningMargin = winningMargin;
    this.odds = odds;
    this.selected = selected;
  }

  getItemOptionText() {
    if (this.itemOption == FbBetItemOption.Hi) {
      return "大";
    } else if (this.itemOption == FbBetItemOption.Lo) {
      return "細";
    } else if (this.itemOption == FbBetItemOption.Home) {
      return "主";
    } else if (this.itemOption == FbBetItemOption.Draw) {
      return "和";
    } else if (this.itemOption == FbBetItemOption.Away) {
      return "客";
    } else if (this.itemOption == FbBetItemOption.HomeHome) {
      return "主-主";
    } else if (this.itemOption == FbBetItemOption.HomeDraw) {
      return "主-和";
    } else if (this.itemOption == FbBetItemOption.HomeAway) {
      return "主-客";
    } else if (this.itemOption == FbBetItemOption.DrawHome) {
      return "和-主";
    } else if (this.itemOption == FbBetItemOption.DrawDraw) {
      return "和-和";
    } else if (this.itemOption == FbBetItemOption.DrawAway) {
      return "和-客";
    } else if (this.itemOption == FbBetItemOption.AwayHome) {
      return "客-主";
    } else if (this.itemOption == FbBetItemOption.AwayDraw) {
      return "客-和";
    } else if (this.itemOption == FbBetItemOption.AwayAway) {
      return "客-客";
    } else {
      return "--";
    }
  }

  getItemOptionClass() {
    if (this.itemOption == FbBetItemOption.Hi) {
      return "red";
    } else if (this.itemOption == FbBetItemOption.Lo) {
      return "blue";
    } else if (this.itemOption == FbBetItemOption.Home) {
      return "red";
    } else if (this.itemOption == FbBetItemOption.Draw) {
      return "green";
    } else if (this.itemOption == FbBetItemOption.Away) {
      return "blue";
    } else if (this.itemOption == FbBetItemOption.HomeHome) {
      return "red";
    } else if (this.itemOption == FbBetItemOption.HomeDraw) {
      return "green";
    } else if (this.itemOption == FbBetItemOption.HomeAway) {
      return "blue";
    } else if (this.itemOption == FbBetItemOption.DrawHome) {
      return "red";
    } else if (this.itemOption == FbBetItemOption.DrawDraw) {
      return "green";
    } else if (this.itemOption == FbBetItemOption.DrawAway) {
      return "blue";
    } else if (this.itemOption == FbBetItemOption.AwayHome) {
      return "red";
    } else if (this.itemOption == FbBetItemOption.AwayDraw) {
      return "green";
    } else if (this.itemOption == FbBetItemOption.AwayAway) {
      return "blue";
    }
  }
}




// WEBPACK FOOTER //
// ./src/model/MatchDetailsHeaderObject.ts